import { useLocation } from 'react-router-dom';

import { AppRoutes } from 'constants/routes-paths.constants';
import { CityForm } from 'page-components/cities/CityForm';
import { PageLayout } from 'page-components/page-layout/PageLayout';

export const City = () => {
  const { pathname } = useLocation();

  const editTitle = pathname === AppRoutes.cityCreate ? 'create_city' : 'edit_city';
  const titleText = pathname.includes('view') ? 'view_city' : editTitle;

  return (
    <PageLayout title={titleText} wrapperClassName='flex flex-col gap-4'>
      <CityForm />
    </PageLayout>
  );
};
